import { getOfferCheckoutData, setOfferCheckoutData } from "./checkoutOfferStorage.js";
export const offerExtraProduct = {
    add: ({ offerToken, key, value }) => {
        setOfferCheckoutData(offerToken, (prevState) => {
            if (prevState.ancillaries) {
                prevState.ancillaries[key] = value;
            }
            else {
                prevState.ancillaries = { [key]: value };
            }
            return prevState;
        });
    },
    remove: ({ offerToken, key }) => {
        setOfferCheckoutData(offerToken, (prevState) => {
            if (prevState.ancillaries) {
                delete prevState.ancillaries[key];
            }
            return prevState;
        });
    },
    get: (offerToken) => getOfferCheckoutData(offerToken)
};
